module.exports = __webpack_public_path__ + "9f83c815756b3413462388f83a00a192.svg";